import { Link, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { onboardingApi } from '../../api/onboarding';
import { SectionHeader } from '../../components/SectionHeader';
import { PageHeader } from '../../components/PageHeader';
import { StatusBadge } from '../../components/StatusBadge';
import { IconActionButton } from '../../components/IconActionButton';
import { Eye } from 'lucide-react';
import { DataTable } from '../../components/DataTable';

/** Real HR monitoring view - genuine completion percentage per employee, computed from actual task counts, not a placeholder. */
export function OnboardingPage() {
  const checklistsQuery = useQuery({ queryKey: ['onboarding-checklists'], queryFn: () => onboardingApi.listAll() });
  const navigate = useNavigate();

  return (
    <div className="page">
      <Link to="/hr">&larr; Back to HR Dashboard</Link>
      <PageHeader title="Onboarding" />

      <div className="panel">
        <SectionHeader title="All Onboarding Checklists" />
        <div className="panel-body">
        {checklistsQuery.data && (
          <DataTable
            rows={checklistsQuery.data.data}
            rowKey={(c) => c.id}
            emptyMessage="No onboarding checklists yet - start one from a Staff Detail page."
            columns={[
              { header: 'Employee', render: (c) => c.employee_name },
              { header: 'Staff ID', render: (c) => c.staff_id ?? '-' },
              { header: 'Progress', render: (c) => `${c.completed_tasks ?? 0} / ${c.total_tasks ?? 0} tasks` },
              { header: 'Status', render: (c) => <StatusBadge status={c.status} label={c.status === 'completed' ? 'Completed' : 'In Progress'} /> },
              { header: '', render: (c) => (
                <span className="row-actions">
                  <IconActionButton icon={Eye} label="View" onClick={() => navigate(`/hr/onboarding/${c.employee_id}`)} />
                  <Link to={`/hr/staff/${c.employee_id}`}>View in Staff Detail</Link>
                </span>
              ) },
            ]}
          />
        )}
      </div>
      </div>
    </div>
  );
}
